'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = require('lodash');

var _data = require('./data');

var _data2 = _interopRequireDefault(_data);

require('./style.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var messages = (0, _reactIntl.defineMessages)({
  SH_NewHireOnBoard: {
    id: 'SH_NewHireOnBoard',
    defaultMessage: '新建報到作業'
  },
  SH_Termination: {
    id: 'SH_Termination',
    defaultMessage: '離職'
  },
  PY_LeaveWithoutPay02: [{
    id: 'PY_LeaveWithoutPay02',
    defaultMessage: '留職停薪'
  }, {
    id: 'SH_Reinstatement',
    defaultMessage: '復職'
  }],
  FD_AccountActivation: [{
    id: 'FD_AccountActivation',
    defaultMessage: '帳號啟用'
  }, {
    id: 'AH_ForgetPassword',
    defaultMessage: '忘記密碼'
  }],
  PT_SetUpTimetable: {
    id: 'PT_SetUpTimetable',
    defaultMessage: '排班'
  },
  PT_OvertimeApplication: {
    id: 'PT_OvertimeApplication',
    defaultMessage: '加班申請'
  },
  PT_RequestSpecialLeaveForm: {
    id: 'PT_RequestSpecialLeaveForm',
    defaultMessage: '申請特殊假別'
  },
  PT_ImportLeaveTypeFlow: {
    id: 'PT_ImportLeaveTypeFlow',
    defaultMessage: '匯入假別流程及調整'
  },
  SH_AttendanceConclusion: [{
    id: 'SH_AttendanceConclusion',
    defaultMessage: '出勤結算'
  }, {
    id: 'PY_SalaryCalculate',
    defaultMessage: '薪資計算'
  }],
  SH_AnnualOperation: {
    id: 'SH_AnnualOperation',
    defaultMessage: '年度作業'
  }
});

function clearLocalStorageExcept(keysToKeep) {
  for (var i = window.localStorage.length - 1; i >= 0; i -= 1) {
    var key = window.localStorage.key(i);
    // 检查当前键是否需要保留
    if (!keysToKeep.includes(key)) {
      // 如果不需要保留，删除该键值对
      window.localStorage.removeItem(key);
    }
  }
}

var MainContent = function (_Component) {
  _inherits(MainContent, _Component);

  function MainContent(props) {
    _classCallCheck(this, MainContent);

    var _this = _possibleConstructorReturn(this, (MainContent.__proto__ || Object.getPrototypeOf(MainContent)).call(this, props));

    var storedData = window.localStorage.getItem('menuItems');
    var storedDataObj = JSON.parse(storedData);
    var targetObject = (0, _lodash.find)(storedDataObj, function (item) {
      return item.isOpen === true;
    });
    /* eslint no-underscore-dangle: ["error", { "allow": ["_target", "__item"] }] */
    var target = {
      label: '',
      index: 0
    };
    if (targetObject) {
      var targetIndex = (0, _lodash.indexOf)(storedDataObj, targetObject);
      target.label = storedDataObj[targetIndex].label;
      target.index = targetIndex;
    }
    _this.state = {
      target: target,
      menuItems: storedDataObj || (0, _lodash.cloneDeep)(_data2.default)
    };
    _this.toggleSubMenu = _this.toggleSubMenu.bind(_this);
    _this.toggleSubMenuSecond = _this.toggleSubMenuSecond.bind(_this);
    _this.renderContent = _this.renderContent.bind(_this);
    return _this;
  }

  _createClass(MainContent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.initPosition();
      this.debouncedHandleScroll = (0, _lodash.debounce)(function () {
        var currentLevel = window.localStorage.getItem('currentLevel') || 'SideMenuLevel1';
        localStorage.setItem(currentLevel + 'Position', _this2[currentLevel].scrollTop);
      }, 300);
      this.SideMenuLevel1.addEventListener('scroll', this.debouncedHandleScroll);
      this.SideMenuLevel2.addEventListener('scroll', this.debouncedHandleScroll);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      if (nextProps.isSwitchOn) {
        setTimeout(function () {
          _this3.initPosition();
        }, 100);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var isShowOnboardingProcess = localStorage.getItem('isShowOnboardingProcess') ? JSON.parse(localStorage.getItem('isShowOnboardingProcess')) : false;
      if (isShowOnboardingProcess === false) {
        var keysToKeep = ['refreshDate', 'locale'];
        clearLocalStorageExcept(keysToKeep);
      }
      this.SideMenuLevel1.removeEventListener('scroll', this.debouncedHandleScroll);
      this.SideMenuLevel2.removeEventListener('scroll', this.debouncedHandleScroll);
      this.debouncedHandleScroll.cancel();
    }
  }, {
    key: 'initPosition',
    value: function initPosition() {
      if (!window.localStorage.getItem('currentLevel')) window.localStorage.setItem('currentLevel', 'SideMenuLevel1');
      var currentLevel = window.localStorage.getItem('currentLevel');
      var initPosition = window.localStorage.getItem(currentLevel + 'Position') ? parseFloat(localStorage.getItem(currentLevel + 'Position')).toFixed(2) : 0;
      this[currentLevel].scrollTop = initPosition;
    }
  }, {
    key: 'toggleSubMenu',
    value: function toggleSubMenu(_ref) {
      var _this4 = this;

      var target = _ref.target,
          type = _ref.type;
      var menuItems = this.state.menuItems;

      var _target = target || {
        label: '',
        index: 0
      };
      var obj = {
        level1: 'SideMenuLevel1',
        level2: 'SideMenuLevel2'
      };
      window.localStorage.setItem('currentLevel', obj[type]);
      var currentStatus = (0, _lodash.get)(menuItems, [_target.index, 'isOpen'], false);
      (0, _lodash.set)(menuItems, [_target.index, 'isOpen'], !currentStatus);
      if (type === 'level1') {
        this.setState({
          target: {
            label: '',
            index: 0
          },
          menuItems: menuItems
        });
      } else {
        this.setState({ target: _target, menuItems: menuItems });
      }
      window.localStorage.setItem('menuItems', JSON.stringify(menuItems));
      setTimeout(function () {
        _this4.initPosition();
      }, 100);
    }
  }, {
    key: 'toggleSubMenuSecond',
    value: function toggleSubMenuSecond(index) {
      var _state = this.state,
          target = _state.target,
          menuItems = _state.menuItems;

      var currentStatus = (0, _lodash.get)(menuItems, [target.index, 'subMenu', index, 'isOpen'], false);
      (0, _lodash.set)(menuItems, [target.index, 'subMenu', index, 'isOpen'], !currentStatus);
      this.setState({ menuItems: menuItems });
      window.localStorage.setItem('menuItems', JSON.stringify(menuItems));
    }

    /* eslint-disable class-methods-use-this */

  }, {
    key: 'renderContent',
    value: function renderContent(index, child) {
      switch (child.type) {
        case 'url':
          return _react2.default.createElement(
            'div',
            { className: 'sidebar-menu-level2-item' },
            _react2.default.createElement(
              'a',
              { key: index, href: child.link },
              _react2.default.createElement(
                _reactIntl.FormattedMessage,
                { id: child.id, defaultMessage: child.defaultMessage },
                function (message) {
                  return _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: message } });
                }
              )
            )
          );
        default:
          return _react2.default.createElement(
            'div',
            {
              key: index,
              className: (0, _classnames2.default)('sidebar-menu-level2-item side-menu-horizontal', {
                'side-menu-bullet-points': child.type === 'bulletPoint',
                'side-menu-text-gray': child.type === 'content'
              })
            },
            child.prefix && _react2.default.createElement(
              'div',
              { className: 'sidebar-menu-m-r-3' },
              child.prefix
            ),
            _react2.default.createElement(
              _reactIntl.FormattedMessage,
              { id: child.id, defaultMessage: child.defaultMessage },
              function (message) {
                return _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: message } });
              }
            )
          );
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var isSwitchOn = this.props.isSwitchOn;
      var _state2 = this.state,
          target = _state2.target,
          menuItems = _state2.menuItems;

      var locale = window.localStorage.getItem('locale') || 'zh-tw';
      var isEN = locale === 'en-us';
      var currentIndex = (0, _lodash.findIndex)(menuItems, function (i) {
        return i.label === target.label;
      });
      var currentItem = menuItems[currentIndex];
      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('sidebar-menu-content', { 'sidebar-menu-content--active': isSwitchOn }) },
        _react2.default.createElement(
          'ul',
          { className: (0, _classnames2.default)('sidebar-menu-list sidebar-menu-main', { 'sidebar-menu-none': currentItem }), ref: function ref(c) {
              _this5.SideMenuLevel1 = c;
            } },
          menuItems.map(function (item, index) {
            if (item.enable) {
              return _react2.default.createElement(
                'li',
                { key: index.label },
                _react2.default.createElement(
                  'div',
                  { className: 'sidebar-hover' },
                  _react2.default.createElement(
                    'div',
                    { className: 'sidebar-menu-list-item', onClick: function onClick() {
                        return _this5.toggleSubMenu({ target: { label: item.label, index: index }, type: 'level2' });
                      } },
                    messages[item.label] instanceof Array ? _react2.default.createElement(
                      'span',
                      { className: 'item-text sidebar-menu-font-16' },
                      _this5.props.intl.formatMessage(messages[item.label][0]),
                      '/',
                      _this5.props.intl.formatMessage(messages[item.label][1])
                    ) : _react2.default.createElement(
                      'span',
                      { className: 'item-text sidebar-menu-font-16' },
                      _this5.props.intl.formatMessage(messages[item.label])
                    ),
                    _react2.default.createElement('i', { className: (0, _classnames2.default)('fa fa-angle-right sidebar-menu-list-arrow-icon sidebar-menu-font-20') })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'sidebar-menu-line-block' },
                    _react2.default.createElement('div', { className: 'sidebar-menu-item-line' })
                  )
                )
              );
            }
            return _react2.default.createElement(
              'li',
              { key: index.label, className: 'sidebar-menu-opacity-3' },
              _react2.default.createElement(
                'div',
                { className: 'sidebar-menu-list-item' },
                messages[item.label] instanceof Array ? _react2.default.createElement(
                  'span',
                  { className: 'item-text' },
                  _this5.props.intl.formatMessage(messages[item.label][0]),
                  '/',
                  _this5.props.intl.formatMessage(messages[item.label][1])
                ) : _react2.default.createElement(
                  'span',
                  { className: 'item-text' },
                  _this5.props.intl.formatMessage(messages[item.label])
                ),
                _react2.default.createElement('i', { className: (0, _classnames2.default)('fa fa-angle-right sidebar-menu-list-arrow-icon') })
              ),
              _react2.default.createElement(
                'div',
                { className: 'sidebar-menu-line-block' },
                _react2.default.createElement('div', { className: 'sidebar-menu-item-line sidebar-menu-opacity-3' })
              )
            );
          })
        ),
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)('sidebar-menu-main', { 'sidebar-menu-none': !currentItem }), ref: function ref(c) {
              _this5.SideMenuLevel2 = c;
            } },
          currentItem && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              {
                className: (0, _classnames2.default)('sidebar-menu-sticky sidebar-menu-sticky-top sidebar-menu-z-200 sidebar-hover', {
                  'sidebar-menu-box-shadow-base': currentItem
                })
              },
              _react2.default.createElement(
                'div',
                { className: (0, _classnames2.default)('sidebar-menu-list-second', { 'sidebar-menu-min-h-80': isEN }), onClick: function onClick() {
                    return _this5.toggleSubMenu({ target: { label: currentItem.label, index: currentIndex }, type: 'level1' });
                  } },
                _react2.default.createElement('i', { className: (0, _classnames2.default)('fa fa-angle-left') }),
                _react2.default.createElement(
                  'div',
                  { className: 'sidebar-menu-list-second-title sidebar-menu-font-16' },
                  messages[currentItem.label] instanceof Array ? _react2.default.createElement(
                    'span',
                    null,
                    this.props.intl.formatMessage(messages[currentItem.label][0]),
                    '/',
                    this.props.intl.formatMessage(messages[currentItem.label][1])
                  ) : _react2.default.createElement(
                    'span',
                    null,
                    this.props.intl.formatMessage(messages[currentItem.label])
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'sidebar-menu-line-block' },
              _react2.default.createElement('div', { className: 'sidebar-menu-item-line' })
            ),
            _react2.default.createElement(
              'ul',
              { className: 'sidebar-menu-list' },
              currentItem.subMenu.map(function (item, index) {
                return _react2.default.createElement(
                  'li',
                  { key: 'currentItem_' + index, className: (0, _classnames2.default)({ 'level2-menu-list-item': item.isOpen }) },
                  _react2.default.createElement(
                    'div',
                    {
                      className: (0, _classnames2.default)('sidebar-menu-sticky sidebar-menu-z-100 sidebar-hover', {
                        'sidebar-menu-box-shadow-base': item.isOpen,
                        'sidebar-menu-sticky-top50': !isEN,
                        'sidebar-menu-sticky-top80': isEN
                      })
                    },
                    _react2.default.createElement(
                      'div',
                      { className: 'sidebar-menu-list-item-second', onClick: function onClick() {
                          return _this5.toggleSubMenuSecond(index);
                        } },
                      _react2.default.createElement(
                        'div',
                        { className: 'side-menu-flex side-menu-justify-start side-menu-items-start sidebar-menu-font-16' },
                        item.prefix && _react2.default.createElement(
                          'span',
                          { className: 'sidebar-menu-m-r-3' },
                          item.prefix
                        ),
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: item.label, defaultMessage: item.title })
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'sidebar-menu-list-arrow-icon' },
                        _react2.default.createElement('i', { className: (0, _classnames2.default)('fa fa-angle-down sidebar-menu-transition', { 'sidebar-menu__icon_active': item.isOpen }) })
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'sidebar-menu-line-block' },
                    _react2.default.createElement('div', { className: 'sidebar-menu-item-line' })
                  ),
                  item.isOpen && _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'ul',
                      { className: 'sidebar-menu-list' },
                      item.subMenu.map(function (level1Item, level1Index) {
                        return _react2.default.createElement(
                          'li',
                          { key: 'level1Index_' + level1Index },
                          _react2.default.createElement(
                            'div',
                            { className: (0, _classnames2.default)('sidebar-menu-level2', { 'sidebar-hover': level1Item.type === 'url' }) },
                            level1Item.label.map(function (level2Item, level2Index) {
                              return _this5.renderContent('level2Index_' + level2Index, level2Item);
                            })
                          ),
                          _react2.default.createElement(
                            'div',
                            { className: 'sidebar-menu-line-block' },
                            _react2.default.createElement('div', { className: 'sidebar-menu-item-line' })
                          )
                        );
                      })
                    )
                  )
                );
              })
            )
          )
        )
      );
    }
  }]);

  return MainContent;
}(_react.Component);

MainContent.propTypes = {
  isSwitchOn: _propTypes2.default.bool,
  intl: _reactIntl.intlShape.isRequired
};

exports.default = MainContent;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@mayo/xe-ui-kit/lib/components/SideMenu/components/MainContent/index.js
 ** module id = 2016
 ** module chunks = 73
 **/